import { render, staticRenderFns } from "./TabRejected.vue?vue&type=template&id=e76df854&scoped=true"
import script from "./TabRejected.vue?vue&type=script&lang=js"
export * from "./TabRejected.vue?vue&type=script&lang=js"
import style0 from "./TabRejected.vue?vue&type=style&index=0&id=e76df854&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e76df854",
  null
  
)

export default component.exports